module.exports = __webpack_public_path__ + "media/images/icon_a10-5514c845141a9f4d97416393da36bcfc.png";